var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandJbcorp2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 46,
    viewBox: "0 0 201 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_794_14437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.684 41.8467C122.178 41.8467 119.434 39.0097 119.434 35.388C119.434 31.7663 122.178 28.9595 125.684 28.9595C127.446 28.9595 128.897 29.5451 129.928 30.6316C131.348 32.1285 133.476 32.7382 135.494 32.2673C134.446 28.0239 130.556 25.2051 125.684 25.2051C119.812 25.2051 115.215 29.6778 115.215 35.388C115.215 41.0982 119.812 45.571 125.684 45.571C130.775 45.571 134.513 42.7762 135.531 38.2491H135.482C133.494 37.8508 131.373 38.4363 130.056 39.9634C129.007 41.1827 127.507 41.8467 125.684 41.8467Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.062 25.2051C143.172 25.2051 138.562 29.6899 138.562 35.4182C138.562 41.1465 143.172 45.571 149.062 45.571C154.952 45.571 159.561 41.1103 159.561 35.4182C159.561 29.7261 154.952 25.2051 149.062 25.2051ZM149.062 41.8165C145.483 41.8165 142.782 39.064 142.782 35.4182C142.782 31.7724 145.483 28.9595 149.062 28.9595C152.641 28.9595 155.342 31.7362 155.342 35.4182C155.342 39.1002 152.641 41.8165 149.062 41.8165Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.064 37.9217C178.228 37.2275 180.119 34.964 180.119 31.8735C180.119 28.0948 177.387 25.6562 173.162 25.6562H163.211V45.1107H167.43V38.151H169.497L175.674 45.1107H180.655L174.381 38.0665L175.064 37.9156V37.9217ZM167.436 34.7949V29.1089H172.613C174.631 29.1089 175.991 30.2437 175.991 31.9338C175.991 33.6239 174.637 34.7949 172.613 34.7949H167.436Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.641 25.6584H183.965V45.1128H188.184V38.9077H193.422C197.867 38.9077 200.744 36.288 200.744 32.2317C200.744 28.1754 197.952 25.6523 193.635 25.6523L193.641 25.6584ZM193.062 35.5516H188.19V29.111H193.062C195.19 29.111 196.623 30.3907 196.623 32.3042C196.623 34.2176 195.226 35.5576 193.062 35.5576V35.5516Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9551 22.8718V34.9803C74.9551 37.9259 72.9491 39.9843 70.0773 39.9843C67.3945 39.9843 65.6446 38.4209 65.1507 35.5779L65.0897 35.2338L58.5352 36.5316L58.5961 36.8636C59.6814 42.5255 63.9739 45.9117 70.0712 45.9117C77.0403 45.9117 81.7291 41.5174 81.7291 34.9863V16.5098H81.3877C77.8391 16.5098 74.9551 19.3649 74.9551 22.8779V22.8718Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.778 36.8755C109.754 35.8433 109.522 34.8836 109.096 34.0204C109.071 33.9661 109.041 33.9178 109.016 33.8695L108.925 33.7005C108.888 33.628 108.852 33.5616 108.815 33.5013C108.571 33.1029 108.272 32.7226 107.931 32.3846L107.833 32.288C107.779 32.2397 107.724 32.1914 107.675 32.1492C106.712 31.274 105.638 30.773 104.907 30.5074C105.486 30.1935 106.279 29.6804 107.01 28.9682C107.608 28.443 108.083 27.7851 108.419 27.0245C108.608 26.6201 108.742 26.1915 108.833 25.7086L108.864 25.5638C108.937 25.1412 108.974 24.6946 108.974 24.2539C108.974 19.5518 105.687 16.5156 100.602 16.5156H86.1211V45.2657H100.645C106.309 45.2657 109.711 42.3502 109.778 37.4489H109.791L109.778 36.8815V36.8755ZM92.6391 33.0365H99.5411C101.687 33.0365 103.132 34.4007 103.132 36.4288C103.132 38.632 101.742 39.9479 99.4131 39.9479H92.6391V33.0365ZM98.9863 28.6H92.6391V21.8214H99.2424C101.224 21.8214 102.663 23.1916 102.663 25.0809C102.663 27.1875 101.187 28.6 98.9863 28.6Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.257812 24.877V38.5609L12.1475 45.5748L12.1231 31.8789L0.257812 24.877Z",
    fill: "url(#paint0_linear_794_14437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6224 0.0859375L12.8242 7.17839V45.5742L24.6224 38.5723V38.3972V0.0859375Z",
    fill: "url(#paint1_linear_794_14437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2695 0.0859375V23.5785L37.1836 30.8641V7.17838L25.2695 0.0859375Z",
    fill: "url(#paint2_linear_794_14437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7525 31.877L26.125 38.7159L37.7525 45.5729L49.5629 38.565L37.7525 31.877Z",
    fill: "url(#paint3_linear_794_14437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1289 31.3123V31.3183L49.9393 38.0063L49.9576 37.9943V24.3466V24.3164L38.1289 31.3123Z",
    fill: "url(#paint4_linear_794_14437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8047 16.8477V30.6764V30.7247V30.767V30.8273L49.6334 23.8315L37.8047 16.8477Z",
    fill: "url(#paint5_linear_794_14437)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_794_14437",
    x1: -7.74179,
    y1: 25.8488,
    x2: 12.1053,
    y2: 39.4651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0696CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_794_14437",
    x1: 20.4458,
    y1: 40.9203,
    x2: 17.4694,
    y2: 9.05605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4d515aCB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_794_14437",
    x1: 28.1352,
    y1: 29.9648,
    x2: 33.3803,
    y2: 4.8633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3DB5B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0696CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_794_14437",
    x1: 34.8624,
    y1: 40.9674,
    x2: 42.2737,
    y2: 35.0699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0696CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_794_14437",
    x1: 45.6895,
    y1: 28.1312,
    x2: 43.9904,
    y2: 35.0084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_794_14437",
    x1: 51.9503,
    y1: 6.75525,
    x2: 46.0211,
    y2: 16.7374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016DB4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_14437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.49,
    height: 45.8263,
    fill: "white",
    transform: "translate(0.253906 0.0859375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandJbcorp2);
export default __webpack_public_path__ + "static/media/brand-jbcorp2.befcf41dff1f7a3c56483276a7dca480.svg";
export { ForwardRef as ReactComponent };